import * as React from 'react';
import { Button } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import BootstrapTable from 'react-bootstrap-table-next';
import PropTypes from 'prop-types';
import ConfirmDialog from '../shared/modals/ConfirmDialog';
import { headerFormatter } from '../../utilities/TableHelper';

class CompaniesTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rows: null,
    };
  }

  componentDidMount() {
    const { companies } = this.props;
    this.formatRows(companies);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { companies } = this.props;
    if (prevProps.companies !== companies) {
      this.formatRows(companies);
    }
  }

  getColumns() {
    const { handleDelete } = this.props;
    return [
      {
        text: 'Pavadinimas',
        dataField: 'name',
        sort: true,
        headerFormatter,
        filter: textFilter({
          placeholder: 'Ieškoti',
        }),
        formatter: (cell, row) => (
          <NavLink to={`/administration/company/${row.id}`}><Button variant="outline-primary" size="sm">{row.name}</Button></NavLink>
        ),
      },
      {
        text: 'Kodas',
        dataField: 'code',
        sort: true,
        headerFormatter,
        filter: textFilter({
          placeholder: 'Ieškoti',
        }),
      },
      {
        text: 'PVM mokėtojo kodas',
        dataField: 'vat',
        sort: true,
        headerFormatter,
        filter: textFilter({
          placeholder: 'Ieškoti',
        }),
      },
      {
        text: 'Adresas',
        dataField: 'address',
        sort: true,
        headerFormatter,
        filter: textFilter({
          placeholder: 'Ieškoti',
        }),
      },
      {
        text: 'Serija',
        dataField: 'seriesName',
        sort: true,
        headerFormatter,
      },
      {
        text: 'Tel. nr',
        dataField: 'phone',
        sort: true,
        headerFormatter,
      },
      {
        text: '',
        dataField: 'id',
        sort: false,
        headerFormatter,
        formatter: (cell, row) => (
          <Button
            variant="danger"
            size="sm"
            onClick={
              () => ConfirmDialog({ text: `Ar tikrai norite ištrinti ${row.name}?`, onConfirm: () => handleDelete(row.id) })
            }
          >
            Trinti
          </Button>
        ),
      },
    ];
  }

  formatRows(companies) {
    const rows = companies.map((row) => ({
      id: row.id,
      name: row.name,
      vat: row.vat,
      code: row.code,
      address: row.address,
      seriesName: row.seriesName,
      companyIbans: row.companyIbans,
      phone: row.phone,
    }));

    this.setState({
      rows,
    });
  }

  render() {
    const { rows } = this.state;
    return (
      <>
        { rows
        && (
          <BootstrapTable
            keyField="id"
            data={rows}
            columns={this.getColumns()}
            filter={filterFactory()}
            bootstrap4
            striped
            hover
            condensed
          />
        )}
      </>
    );
  }
}

export default CompaniesTable;

CompaniesTable.propTypes = {
  companies: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    vat: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    seriesName: PropTypes.string.isRequired,
    phone: PropTypes.string,
    companyIbans: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        iban: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired).isRequired,
  handleDelete: PropTypes.func.isRequired,
};
